import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  ModelBase,
} from "@models";
import { 
  CreatureGroup, 
} from "@dndModels";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import SuggestionStringBox from "@dndComponents/select/SuggestionStringBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function CreatureGroupEdit({ obj: param_obj }: Props) {
  const [obj, setObj] = useState<CreatureGroup>(param_obj instanceof CreatureGroup ? param_obj : api.applyWorkingOn(new CreatureGroup()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  return (
    <ModelBaseInput
      obj={obj}
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: ModelBase) => {
        if (changed instanceof CreatureGroup) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}>
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <SuggestionStringBox 
            name="Settings"
            field="settings"
            values={obj.settings}
            multiple
            onChange={(values: string[]) => {
              const new_obj = obj;
              new_obj.settings = values;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <SuggestionStringBox 
            name="Native Planes"
            field="native_planes"
            values={obj.native_planes}
            multiple
            onChange={(values: string[]) => {
              const new_obj = obj;
              new_obj.native_planes = values;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
      </Grid>
    </ModelBaseInput>
  );
}